// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  gameId: __t.u64().primaryKey().name("game_id"),
  contractId: __t.u64().name("contract_id"),
  minPlayers: __t.u8().name("min_players"),
  maxPlayers: __t.u8().name("max_players"),
  teamSize: __t.u8().name("team_size"),
  ruleset: __t.string(),
  jurisdiction: __t.string(),
});
